var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ccc-link",class:{ [`ccc-link-${_vm.size}`]: true },attrs:{"href":"https://capitalcitychorus.org","target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/img/ccc-logo-std-black-bgtransparent.png"),"alt":"Organized by Ottawa's Capital City Chorus"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }